import axios from "axios";

import {
  getUrlParameter
} from "./actions";

export const setAuthorization = (token: string) => {
  axios.defaults.headers.common[
    "userToken"
  ] = token;
};

export const getTeacherAuthToken = (): string | null => {
  const token = localStorage.getItem(`board-authtoken`);
  if (token) {
    return token;
  }
  return null;
};

export const setAuthToken = (token: string) => {
  const BoardId = getUrlParameter("board");
  setAuthorization(token);
  localStorage.setItem(`board-${BoardId}`, token);
};

export const getAuthToken = (): string | null => {
  const BoardId = getUrlParameter("board");
  const token = localStorage.getItem(`board-${BoardId}`);
  if (token) {
    return token;
  }
  return null;
};